import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AuthState } from 'src/app/store/auth/auth.reducer';
import { login } from 'src/app/store/auth/auth.actions';
import { TrackingService } from 'src/app/modules/shared/services/tracking.service';
import * as fromEvents from '../../tracking/auth.events';
@Component({
    selector: 'app-login-page',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginPageComponent implements OnInit {
  loginForm = new UntypedFormGroup({
    username: new UntypedFormControl(''),
    password: new UntypedFormControl(''),
  });

  loading = this.store.select(state => state.auth.loginForm.loading);
  error = this.store.select(state => state.auth.loginForm.error);

  constructor(private store: Store<{ auth: AuthState }>, private tracking: TrackingService) {
    this.tracking.track(fromEvents.loginPageShownEvent());
  }

  ngOnInit() {}

  submitForm() {
    if (!this.loginForm.valid) {
      return;
    }
    this.store.dispatch(
      login({
        username: this.loginForm.value.username,
        password: this.loginForm.value.password,
      }),
    );
  }
}
